import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import departmentService from '../../services/departmentService';
import './DepartmentTree.css';

const DepartmentTreeNode = ({ department, level = 0 }) => {
  const [isExpanded, setIsExpanded] = useState(level < 2); // Auto-expand first 2 levels

  const hasChildren = department.sub_departments && department.sub_departments.length > 0;
  const teamSize = department.employees?.length || 0;
  const budgetUtilization = departmentService.calculateBudgetUtilization(
    department.budget_allocated,
    department.budget_spent
  );

  const toggleExpand = (e) => {
    e.preventDefault();
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="tree-node">
      <div className="tree-node-content" style={{ paddingLeft: `${level * 24}px` }}>
        {hasChildren && (
          <button 
            className={`expand-button ${isExpanded ? 'expanded' : ''}`}
            onClick={toggleExpand}
          >
            <i className={`fas fa-chevron-${isExpanded ? 'down' : 'right'}`}></i>
          </button>
        )}
        {!hasChildren && <span className="expand-placeholder"></span>}
        
        <div className="node-info">
          <div className="node-header">
            <Link to={`/app/departments/${department.id}`} className="node-name">
              <i className="fas fa-building"></i>
              {department.name}
            </Link>
            {department.code && (
              <span className="node-code">{department.code}</span>
            )}
          </div>
          
          <div className="node-meta">
            {department.manager && (
              <span className="meta-badge">
                <i className="fas fa-user-tie"></i>
                {department.manager.first_name} {department.manager.last_name}
              </span>
            )}
            <span className="meta-badge">
              <i className="fas fa-users"></i>
              {teamSize} member{teamSize !== 1 ? 's' : ''}
            </span>
            {department.budget_allocated > 0 && (
              <span className="meta-badge">
                <i className="fas fa-dollar-sign"></i>
                {departmentService.formatBudget(department.budget_allocated)}
                <span className="budget-util" style={{ 
                  color: departmentService.getBudgetStatusColor(budgetUtilization) 
                }}>
                  ({budgetUtilization}%)
                </span>
              </span>
            )}
          </div>
        </div>

        <div className="node-actions">
          <Link to={`/app/departments/${department.id}/edit`} className="btn btn-sm btn-outline-primary">
            <i className="fas fa-edit"></i> Edit
          </Link>
        </div>
      </div>

      {hasChildren && isExpanded && (
        <div className="tree-children">
          {department.sub_departments.map(child => (
            <DepartmentTreeNode 
              key={child.id} 
              department={child} 
              level={level + 1}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const DepartmentTree = ({ departments, loading }) => {
  if (loading) {
    return <div className="tree-loading">Loading department hierarchy...</div>;
  }

  if (!departments || departments.length === 0) {
    return (
      <div className="tree-empty">
        <i className="fas fa-sitemap"></i>
        <p>No departments found</p>
      </div>
    );
  }

  return (
    <div className="department-tree">
      {departments.map(department => (
        <DepartmentTreeNode key={department.id} department={department} />
      ))}
    </div>
  );
};

export default DepartmentTree;

